import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Events from '../containers/Events';
import Schedule from '../containers/Schedule';
// import Results from '../containers/Results';

const Router = () => (
  <main>
    <Switch>
      <Route path='/register' />
      <Route path='/signin' />
      <Route path='/signup' />
      <Route path='/confirm' />
      <Route path='/resetpassword' />
      <Route path='/forgotpassword' />
      <Route path='/schedule' component={Schedule} />
      <Route component={Events} />
    </Switch>
  </main>
);

export default Router;



// WEBPACK FOOTER //
// ./src/public/routes/index.js